// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"e30316c2","283":"632c7ff5","555":"18411318","591":"f8334ff0","615":"2bf9ebab","810":"c6030f0e","818":"020d7373","936":"643af331"}[chunkId] + ".chunk.js";
};